
// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import SoftSelect from "components/SoftSelect";
import userInvitePP from "assets/images/crop.jpg";
import { ACCESS_TYPE_OPTIONS } from "constants/portal";

function ExternalUsersSharCard({ shareUsersEmails, setShareUsersEmails }) {
  const handleShareTypeChange = (email, selectedOption) => {
    setShareUsersEmails((prevData) =>
      prevData.map((data) =>
        data.email === email ? { ...data, access_type: selectedOption.value } : data
      )
    );
  };

  const renderShareUsers = shareUsersEmails?.map(({ email, access_type }) => (
    <SoftBox key={email} component="li" display="flex" alignItems="center" py={1} mb={1}>
      <SoftBox mr={2}>
        <SoftAvatar src={userInvitePP} alt="something here" variant="rounded" />
      </SoftBox>
      <SoftBox display="flex" flexDirection="column" alignItems="flex-start">
        <SoftTypography variant="caption" color="text">
          {email}
        </SoftTypography>
      </SoftBox>
      <SoftBox ml="auto" width="200px">
        <SoftSelect
          placeholder="Select access type"
          defaultValue={
            ACCESS_TYPE_OPTIONS.find((at) => at.value === access_type) || {
              value: "readOnly",
              label: "Read Only",
            }
          }
          options={ACCESS_TYPE_OPTIONS}
          onChange={(selectedOption) => {
            handleShareTypeChange(email, selectedOption);
          }}
        />
      </SoftBox>
    </SoftBox>
  ));

  return (
    <SoftBox p={2}>
      <SoftBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
        {renderShareUsers}
      </SoftBox>
    </SoftBox>
  );
}

export default ExternalUsersSharCard;
